import { Component, EventEmitter, Output, OnInit, Input } from '@angular/core';
import { FileService } from 'src/app/core/services/http/file/file.service';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent implements OnInit {
  @Output() fileChange = new EventEmitter<File>();
  @Input() getPrefix = true;

  file: File | undefined | null;
  cssClass = '';
  filePrefix: string | undefined;
  isPrefixMisMatch = false;
  isPrefixExactMatch = false;
  fileName: string | undefined;
  isEmptyFilename = false;
  isInvalidFormat = false;

  constructor(private fileService: FileService) {}

  ngOnInit(): void {
    if(this.getPrefix){
      this.getFilePrefix();
    }
  }

  private getFilePrefix(): void {
    this.fileService.getPrefix().subscribe(response => {
      this.filePrefix = response.sftpFilePrefix;
    })
  }

  onFileChange(event: any): void {
    if (!event.target.files.length) {
      return;
    }
  
    const file = event.target.files[0] as File;
    const nameWithoutExt = this.getFileNameWithoutExtension(file.name);
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    
    this.fileName = nameWithoutExt;
    
    if (this.isInvalidFileName(nameWithoutExt)) {
      this.resetFileState();
      this.isEmptyFilename = true;
      return;
    }
  
    if (fileExtension !== 'csv') {
      this.resetFileState();
      this.isInvalidFormat = true;
      return;
    }
  
    this.validateFilePrefix(file, nameWithoutExt);
  }
  
  private isInvalidFileName(name: string): boolean {
    return !name || name.trim() === '';
  }
  
  private resetFileState(): void {
    this.file = undefined;
    this.cssClass = "";
    this.isPrefixMisMatch = false;
    this.isPrefixExactMatch = false;
    this.isEmptyFilename = false;
    this.isInvalidFormat = false;
  }
  
  private validateFilePrefix(file: File, nameWithoutExt: string): void {
    const prefixWithUnderscore = this.filePrefix ? this.checkFilePrefix(this.filePrefix) : '';
    const isExactPrefixMatch = nameWithoutExt === prefixWithUnderscore;
    const startsWithPrefix = file.name.startsWith(prefixWithUnderscore);
    
    if (!this.filePrefix || (startsWithPrefix && !isExactPrefixMatch)) {
      this.acceptFile(file);
    } else {
      this.rejectFile(isExactPrefixMatch, startsWithPrefix);
    }
  }
  
  private acceptFile(file: File): void {
    this.file = file;
    this.cssClass = "fileSelected";
    this.isPrefixMisMatch = false;
    this.isPrefixExactMatch = false;
    this.fileChange.emit(file);
  }
  
  private rejectFile(isExactMatch: boolean, startsWithPrefix: boolean): void {
    this.isPrefixExactMatch = isExactMatch;
    this.isPrefixMisMatch = !startsWithPrefix;
    this.file = undefined;
  }

  checkFilePrefix(prefix: string): string {
    if(prefix.endsWith("_")){
      return prefix;
    }else{
      return prefix + "_";
    }
  }

  getFileNameWithoutExtension(fileName: string): string {
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex !== -1) {
      return fileName.substring(0, lastDotIndex);
    }
    return this.checkFilePrefix(fileName);
  }
}
